/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiGeoGetNearestServicePointGet$Params {
  country?: string;
  zone?: string;
  street?: string;
  number?: string;
  language?: string;
  type?: string;
  limit?: string;
  checklist?: string;
  info?: string;
  checkOpen?: string;
}

export function apiGeoGetNearestServicePointGet(http: HttpClient, rootUrl: string, params?: ApiGeoGetNearestServicePointGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiGeoGetNearestServicePointGet.PATH, 'get');
  if (params) {
    rb.query('country', params.country, {});
    rb.query('zone', params.zone, {});
    rb.query('street', params.street, {});
    rb.query('number', params.number, {});
    rb.query('language', params.language, {});
    rb.query('type', params.type, {});
    rb.query('limit', params.limit, {});
    rb.query('checklist', params.checklist, {});
    rb.query('info', params.info, {});
    rb.query('checkOpen', params.checkOpen, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiGeoGetNearestServicePointGet.PATH = '/api/geo/get-nearest-service-point';
